<template>
  <div v-if="loading" class="loading-container">Loading...</div>

  <div v-else>
    <div class="action-buttons">
      <button
        class="btn btn-sm btn-primary"
        @click="download_PDF('invoice', patient.name + '_invoice')"
      >
        <b style="font-size: 1.5em">🖨️</b> Print Invoice
      </button>

      <button
        v-if="canEditInvoice"
        class="btn btn-sm btn-danger"
        @click="show_close_invoice_confirmation_modal"
      >
        <b style="font-size: 1.5em">🛑</b> Close Invoice
      </button>

      <button
        v-if="canEditInvoice && !editMode"
        class="btn btn-sm btn-primary"
        @click="editMode = true"
      >
        <b style="font-size: 1.5em">📝</b> Edit Invoice
      </button>

      <button
        v-if="!editMode"
        class="btn btn-sm btn-info"
        @click="configBillType = true"
      >
        <b style="font-size: 1.5em">⚙️</b> Configure Bill Tarrif
      </button>

      <!-- <button
        v-if="canEditInvoice"
        class="btn btn-sm btn-secondary"
        @click="startInsuranceSort"
      >
        Sort To Insurance
      </button> -->

      <!-- <button
        v-if="patient.is_paid != '1' && patient.is_paid != 1"
        class="btn btn-sm btn-success"
        @click="show_payment_modal"
      >
        Make Payment
      </button> -->

      <!-- <button
        class="btn btn-sm btn-success"
        @click="show_accounts_receivable_ledger_modal"
      >
        Accounts Receivable Ledger
      </button> -->
    </div>

    <div
      v-if="selectionMode"
      class="insurance-selection-actions"
      style="margin: 10px 0; text-align: center"
    >
      <button class="btn btn-sm btn-secondary" @click="selectAllBills">
        Select All
      </button>
      <button
        style="background-color: #fff"
        class="btn btn-sm position-relative"
        @click="submitInsuranceBills"
      >
        Submit to Insurance
        <span
          class="badge bg-danger text-white position-absolute top-0 start-100 translate-middle"
          style="font-size: 1rem; padding: 4px 8px"
        >
          {{ selectedBills.length }}
        </span>
      </button>
      <button class="btn btn-sm btn-warning" @click="cancelInsuranceSort">
        Cancel
      </button>
    </div>

    <div id="invoice" class="invoice-box">
      <div class="invoice-header">
        <div class="center-img">
          <img :src="logoToShow" class="branding" alt="logo" />
        </div>
        <h2>{{ company.company_name }}</h2>
        <p>{{ company.address + ", " + company.company_location }}</p>
        <p>
          Tel: <b>{{ company.company_phone }}</b> | Email:
          <b>{{ company.company_email }}</b>
        </p>
        <p style="color: black; font-size: 2em">
          <strong>Invoice No:</strong> INV-{{ patient.id }}
        </p>
      </div>

      <div class="row">
        <div class="patient-details col-6">
          <p><strong>Patient Name:</strong> {{ patient.name }}</p>
          <p><strong>ID/Passport Number:</strong> {{ patient.id_number }}</p>
          <p><strong>Date:</strong> {{ formatDateTime(patient.created_at) }}</p>
          <!-- <p><strong>Invoice #:</strong> {{ patient.id }}</p> -->
        </div>

        <div class="patient-details col-6">
          <p><strong>Insurance Company:</strong> {{ insurance_company }}</p>
          <p><strong>Insurance Scheme:</strong> {{ insurance_scheme }}</p>
          <!-- <p><strong>Date:</strong> {{ formatDateTime(patient.created_at) }}</p> -->
          <!-- <p><strong>Invoice #:</strong> {{ patient.id }}</p> -->
        </div>
      </div>

      <table>
        <thead>
          <tr>
            <th>Service</th>
            <th>Qty</th>
            <th>Unit Price (KES)</th>
            <th>Amount (KES)</th>
            <th v-if="editMode">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(bill, index) in bills"
            :key="bill.id"
            :class="{
              'selected-bill': selectedBills.find((b) => b.id === bill.id),
            }"
            @click="selectionMode ? toggleBillSelection(bill) : null"
            style="cursor: pointer"
            v-show="bill.quantity > 0"
          >
            <td v-if="editMode">
              <input v-model="bill.charge_name" />
            </td>
            <td v-else>{{ bill.charge_name }}</td>

            <td v-if="editMode">
              <input
                type="number"
                v-model.number="bill.quantity"
                @input="recalculateAmount(index)"
              />
            </td>
            <td v-else>{{ bill.quantity }}</td>

            <td v-if="editMode">
              <input
                type="number"
                v-model.number="bill.unit_price"
                @input="recalculateAmount(index)"
              />
            </td>
            <td v-else>{{ bill.unit_price }}</td>

            <td>{{ bill.amount_due }}</td>

            <td v-if="editMode">
              <button
                class="btn btn-sm btn-danger"
                @click.stop="removeBill(index)"
              >
                Remove
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="editMode" style="margin-top: 10px">
        <button class="btn btn-sm btn-secondary" @click="addBill">
          + Add Row
        </button>
      </div>

      <div class="totals">
        <div>Total: KES {{ total_bills }}</div>
        <div>Discount: KES {{ patient.discount_amount }}</div>
        <div class="grand-total">Grand Total: KES {{ cumulating_total }}</div>
      </div>

      <div v-if="editMode" class="edit-actions">
        <button class="btn btn-sm btn-success" @click="saveInvoice">
          Save Changes
        </button>
        <button class="btn btn-sm btn-warning" @click="cancelEdit">
          Cancel Edit
        </button>
      </div>

      <div class="footer">
        Thank you for visiting {{ company.company_name }}.<br /><i
          >This invoice serves as an official record of services rendered.</i
        >
      </div>
    </div>

    <!-- Modals -->
    <CloseInvModal
      :invoice_id="invoice_id"
      @close-inv-modal="close_inv_modal"
      v-if="show_close_invoice_modal"
    />
    <PaymentModal
      :invoice_id="invoice_id"
      @close-pay-modal="close_pay_modal"
      v-if="show_pay_modal"
    />
    <AccountsReceivableLedger
      v-if="display_accounts_receivable_ledger_modal"
      :invoice_id="invoice_id"
      @close-accounts-legger-modal="close_accounts_receivable_ledger_modal"
    />

    <insurannce_prompt
      @close-pro="close_prompt"
      :bill="bill_to_send"
      v-if="dispaly_insurance_prompt"
      @send-update="applyUpdatedBill"
    />

    <insurance_confirmation
      @close-conf="hide_bill_confirmation"
      :bills="selectedBills"
      :invoice_id="invoice_id"
      v-if="display_bill_confirmation"
    />

    <ConfigureBill
      @close-conf="close_tarrif_mod"
      :invoice_id="invoice_id"
      v-if="configBillType"
    />
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import utc_local_time from "../../../timezone/utc_local_time";
import logo from "@/assets/img/org.png";
import CloseInvModal from "./confirm_close_invoice.vue";
import PaymentModal from "./pay_modal.vue";
import AccountsReceivableLedger from "./acc_receivable_ledger_modal.vue";
import insurannce_prompt from "./insurannce_prompt.vue";
import insurance_confirmation from "./insurance_confirmation.vue";
import ConfigureBill from "./configure_bill.vue";

export default {
  name: "InvoiceDetail",
  data() {
    return {
      company: {},
      patient: {},
      bills: [],
      total_bills: 0,
      cumulating_total: 0,
      loading: false,
      logo,
      editMode: false,
      configBillType: false,
      invoice_id: this.$route.params.invoiceid,
      show_close_invoice_modal: false,
      show_pay_modal: false,
      display_accounts_receivable_ledger_modal: false,
      selectionMode: false,
      selectedBills: [],
      dispaly_insurance_prompt: false,
      bill_to_send: {},
      onlold_value: {},
      insurance_company: "",
      insurance_scheme: "",
      display_bill_confirmation: false,
    };
  },
  components: {
    CloseInvModal,
    PaymentModal,
    AccountsReceivableLedger,
    insurannce_prompt,
    insurance_confirmation,
    ConfigureBill,
  },
  computed: {
    logoToShow() {
      return this.$store.getters.currentLogo || this.logo;
    },
    canEditInvoice() {
      return (
        this.patient.invoice_status != 1 &&
        this.patient.is_paid != "1" &&
        this.patient.is_paid != 1
      );
    },
  },
  methods: {
    close_tarrif_mod() {
      this.callApiData();
      this.configBillType = false;
    },
    formatDateTime(datetime) {
      return utc_local_time(datetime);
    },
    hide_bill_confirmation() {
      this.display_bill_confirmation = false;
      this.callApiData();
    },
    download_PDF(div_id, doc_name) {
      console.log(doc_name);

      this.printDiv(div_id);
    },
    printDiv(div_id) {
      const divToPrint = document.getElementById(div_id);
      if (!divToPrint) return alert("Div not found!");
      const printContents = divToPrint.cloneNode(true);
      const printWindow = window.open("", "_blank", "width=900,height=650");
      printWindow.document.open();
      printWindow.document.write(
        `<html><head><title>Invoice</title><style>body{font-family:Arial,sans-serif;background:white;margin:0;padding:20px}.invoice-box{max-width:900px;margin:auto;padding:20px;border:1px solid black;background:white}.invoice-header{text-align:center}.branding{height:7em;width:auto}table{width:100%;border-collapse:collapse;margin-top:10px}table th,table td{border:1px solid #ccc;padding:8px}.totals{margin-top:20px;text-align:right}.grand-total{font-weight:bold;font-size:1.2em}.footer{text-align:center;margin-top:30px}</style></head><body>${printContents.outerHTML}</body></html>`
      );
      printWindow.document.close();
      printWindow.onload = function () {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      };
    },

    show_accounts_receivable_ledger_modal() {
      this.display_accounts_receivable_ledger_modal = true;
    },
    close_accounts_receivable_ledger_modal() {
      this.display_accounts_receivable_ledger_modal = false;
    },
    show_close_invoice_confirmation_modal() {
      this.show_close_invoice_modal = true;
    },
    show_payment_modal() {
      this.show_pay_modal = true;
    },
    close_pay_modal() {
      this.show_pay_modal = false;
    },
    close_inv_modal() {
      this.show_close_invoice_modal = false;
      this.callApiData();
    },

    recalculateAmount(index) {
      const bill = this.bills[index];
      bill.amount_due = bill.quantity * bill.unit_price;
      this.updateTotals();
    },
    addBill() {
      this.bills.push({
        id: Date.now(),
        is_new: true,
        charge_name: "",
        quantity: 1,
        unit_price: 0,
        amount_due: 0,
      });
    },
    removeBill(index) {
      this.bills.splice(index, 1);
      this.updateTotals();
    },
    updateTotals() {
      this.total_bills = this.bills.reduce(
        (sum, b) => sum + Number(b.amount_due),
        0
      );
      this.cumulating_total =
        this.total_bills - parseFloat(this.patient.discount_amount || 0);
    },
    async saveInvoice() {
      const url = `update_invoice/${this.invoice_id}`;
      await generalApiRequest(url, "POST", { bills: this.bills }, 1);
      this.editMode = false;
      this.callApiData();
    },
    cancelEdit() {
      this.editMode = false;
      this.callApiData();
    },
    async callApiData() {
      this.loading = true;
      const url = "get_insurance_invoice_details/" + this.invoice_id;
      const resp = await generalApiRequest(url, "GET", {}, 1);

      //   console.log(resp);

      this.company = resp.company;
      this.insurance_company = resp.insurance_company;
      this.insurance_scheme = resp.insurance_scheme;
      this.patient = resp.patient;
      this.bills = resp.bills.map((b) => ({ ...b }));
      this.updateTotals();
      this.loading = false;
    },

    // Insurance Sorting Methods
    startInsuranceSort() {
      this.selectionMode = true;
      this.selectedBills = [];
    },
    close_prompt() {
      this.bill_to_send = {};
      this.dispaly_insurance_prompt = false;
    },
    applyUpdatedBill(updatedBill) {
      this.onlold_value = updatedBill;

      this.toggleBillSelectionReal(updatedBill);
      // const index = this.bills.findIndex((b) => b.id === updatedBill.id);
      // if (index !== -1) {
      //   this.$set(this.bills, index, updatedBill);
      // }
    },
    get_input_from_prompt(bill) {
      this.bill_to_send = bill;
      this.dispaly_insurance_prompt = true;
    },
    toggleBillSelectionReal(bill) {
      const index = this.selectedBills.findIndex((b) => b.id === bill.id);
      if (index === -1) {
        const qty = bill.quantity;
        // prompt(
        //   `Enter quantity for insurance for ${bill.charge_name}`,
        //   bill.quantity
        // );

        if (qty !== null && !isNaN(qty)) {
          this.selectedBills.push({ ...bill, insurance_quantity: Number(qty) });
        }
      } else {
        this.selectedBills.splice(index, 1);
      }
    },
    toggleBillSelection(bill) {
      this.get_input_from_prompt(bill);

      // const index = this.selectedBills.findIndex((b) => b.id === bill.id);
      // if (index === -1) {
      //   const qty = prompt(
      //     `Enter quantity for insurance for ${bill.charge_name}`,
      //     bill.quantity
      //   );

      //   // console.log(
      //   //   "this is the fetched quantity" + this.onlold_value.quantity
      //   // );

      //   if (qty !== null && !isNaN(qty)) {
      //     this.selectedBills.push({ ...bill, insurance_quantity: Number(qty) });
      //   }
      // } else {
      //   this.selectedBills.splice(index, 1);
      // }
    },
    selectAllBills() {
      this.selectedBills = this.bills.map((b) => ({
        ...b,
        insurance_quantity: b.quantity,
      }));
    },
    submitInsuranceBills() {
      this.display_bill_confirmation = true;
    },
    cancelInsuranceSort() {
      this.selectionMode = false;
      this.selectedBills = [];
    },
  },
  mounted() {
    this.callApiData();
  },
};
</script>

<style scoped>
.invoice-box {
  max-width: 900px;
  margin: auto;
  padding: 20px;
  border: 1px solid black;
  background: white;
}
.invoice-header {
  text-align: center;
}
.branding {
  height: 7em;
  width: auto;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}
table th,
table td {
  border: 1px solid #ccc;
  padding: 8px;
}
.action-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 10px;
}
.totals {
  margin-top: 20px;
  text-align: right;
}
.grand-total {
  font-weight: bold;
  font-size: 1.2em;
}
.footer {
  text-align: center;
  margin-top: 30px;
}
.edit-actions {
  margin-top: 15px;
  text-align: center;
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
  font-size: 2em;
}
.selected-bill {
  background-color: #d1ecf1;
}
</style>
